import { useQuery } from '@apollo/client';
import type { UseRelatedAccountsFetch } from '@openx/types/package/PackageHookTypes';
import { useMemo } from 'react';
import { GetOrganizationsListDocument } from '../../../graphql/query/organizations/GetOrganizationsList.generated';

export const useRelatedAccountsFetch: UseRelatedAccountsFetch = <
  T extends { account_uid?: string | null; account_id?: string | null },
>(
  packageList: T[],
  options?: { enabled?: boolean }
) => {
  const variables = useMemo(
    () =>
      packageList.length ? { accountIds: packageList.map(item => item.account_id).filter(Boolean) as string[] } : {},
    [packageList]
  );
  const { data, loading, refetch } = useQuery(GetOrganizationsListDocument, {
    skip: options?.enabled === false,
    variables: {
      where: {
        exchange_account_network_id: { _in: variables.accountIds },
      },
    },
  });

  const mapById = useMemo(() => {
    const account = data?.account || [];

    return account.reduce((acc, account) => {
      acc[account.exchange_account_network?.uid] = {
        contextual_providers: account.exchange_account_network?.contextual_providers || {},
        id: account?.exchange_account_network?.id,
        name: account.name,
      };
      return acc;
    }, {});
  }, [data?.account]);

  return {
    loading,
    refetch,
    relatedAccounts: mapById,
  };
};
